import React, { memo, useState, useEffect } from 'react';
import closeImage from '@/assets/images/login/inp_close.png';
import luckImage from '@/assets/images/login/lock.png';
import userImage from '@/assets/images/login/user.png';
import { Form, Input, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import '../index.less';
import { isAccount, isPassword } from '@/utils';
import { registerSliderProps, apiGetRegisterSlider } from '../server';
import { UserState } from '@/store/module/user';
// import { aliyunSlideProps } from '@/components/Login/typings';
import Verify from '../slideVerifyNew';
import { LoginForm, LOGIN_HISTORY_KEY } from '../types';
import { getLocalStorage, setLocalStorage } from '@/utils/localStorage';
import AccountExists from '../dialog';
import HeadBtn from '../components/headBtn';
import { lmessage } from '../message';
import { loginCollect } from '@/views/login/collect/loginCollect';
import StorageFn from '@/utils/electronStorage';
import Footer from '../components/footer';
import TemplateModal from '../modal/templateModal';

interface sign extends registerSliderProps {
  policy?: boolean;
}

function LoginSignUp() {
  const [form] = Form.useForm();
  const history: any = useHistory();
  const [canSign, setCanSign] = useState<boolean>(false);
  const [showVerify, setShowVerify] = useState<boolean>(false);
  const [dialogVisible, setDialogVisible] = useState<boolean>(false);
  const [dialogTitle, setDialogTitle] = useState<string>('');
  const [dialogContent, setDialogContent] = useState<string | undefined>('');
  const [isComposition, setIsComposition] = useState<boolean>(false);
  let [clause, setClause] = useState<boolean>(false);
  const [currentNum, setCurrentNum] = useState<number>(1);
  const [connectModalShow, setConnectModalShow] = useState<boolean>(false);

  useEffect(() => {
    loginCollect(3300, 1);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  function formSubmit() {
    if (!clause) {
      setConnectModalShow(true);
      return;
    }
    loginCollect(3303, 2);
    form.validateFields().then(res => {
      const values = res as sign;
      values.username = values.username.trim();
      values.password = values.password.trim();
      if (!values.username || !isAccount(values.username)) {
        return lmessage.error('用户名只能是字母开头的字符串,长度6-20位');
      } else if (values.password.length < 6) {
        return lmessage.error('密码字符不得低于6位');
      } else if (!values.password || !isPassword(values.password)) {
        return lmessage.error('密码格式不正确');
      } else if (values.password !== values.recoveryPwd) {
        return lmessage.error('两次密码不一致');
      } else if (values.username === values.password) {
        return lmessage.error('账号密码不可以相同');
      }
      // delete values.recoveryPwd;
      // setShowVerify(true);
      slideChange();
    });
  }
  function changeStatus() {
    const formData: registerSliderProps = form.getFieldsValue();
    if (formData.username && formData.password && formData.recoveryPwd) {
      setCanSign(true);
    } else {
      setCanSign(false);
    }
  }
  const handleComposition = (e: any) => {
    if (e.type === 'compositionend') {
      setIsComposition(false);
    } else {
      setIsComposition(true);
    }
  };
  const handlePercentMatchUser = (e: any) => {
    if (isComposition === true) return;
    const value = e.target.value;
    form.setFieldsValue({
      username: value.replace(/[\W]/g, '')
    });
    changeStatus();
  };
  const handlePercentMatchPwd = (e: any) => {
    if (isComposition === true) return;
    const value = e.target.value;
    form.setFieldsValue({
      password: value.replace(/[\W]/g, '')
    });
    changeStatus();
  };
  const handlePercentMatchRecoveryPwd = (e: any) => {
    if (isComposition === true) return;
    const value = e.target.value;
    form.setFieldsValue({
      recoveryPwd: value.replace(/[\W]/g, '')
    });
    changeStatus();
  };
  function backChange() {
    setShowVerify(false);
  }
  function slideChange() {
    // function slideChange(params: aliyunSlideProps) {
    const formData: sign = form.getFieldsValue();
    delete formData.recoveryPwd;
    apiGetRegisterSlider({ ...formData }).then(({ data }: { data: UserState }) => {
      if (data.code && (data.code === 20045 || data.code === 20010)) {
        // TODO 调试增加弹窗
        lmessage.error(data.msg);
        return;
      }
      if (data.code && data.code === 20017) {
        setCurrentNum(1);
        setDialogVisible(true);
        setDialogTitle('注册失败');
        setDialogContent(data.msg);
        return;
      }
      history.push('/login/bindPhone', { bind_phone_token: data.data?.bind_phone_token, type: 'register' });
      setStorage(formData);
    });
    setShowVerify(false);
  }
  function setStorage(userinfo: LoginForm) {
    const historyList = getLocalStorage(LOGIN_HISTORY_KEY) ? JSON.parse(getLocalStorage(LOGIN_HISTORY_KEY)) : [];
    let isRepeat = false;
    for (let i = 0, len = historyList.length; i < len; i += 1) {
      if (historyList[i].username === userinfo.username) {
        historyList[i] = userinfo;
        isRepeat = true;
        break;
      }
    }
    if (!isRepeat) {
      historyList.push(userinfo);
    }
    setLocalStorage(LOGIN_HISTORY_KEY, JSON.stringify(historyList));
    StorageFn.electronSetData(LOGIN_HISTORY_KEY, JSON.stringify(historyList));
  }
  const footerBtnChange = (params: string) => {
    if (params === 'login') {
      return history.replace('/login/account');
    }
    return setDialogVisible(false);
  };
  const focus = () => {
    loginCollect(3301, 3);
  };
  const getFocus = () => {
    pwdFocusCollect();
  };
  const pwdFocus = () => {
    pwdFocusCollect();
  };
  const pwdFocusCollect = () => {
    loginCollect(3302, 3);
  };
  return (
    <div className="main_position_box">
      <HeadBtn headBtnType={2}></HeadBtn>
      <div className="login-switch_mold" style={{ marginBottom: '0' }}>
        <div className="currnt_f">注册账号</div>
      </div>
      <div className="login-tips_hint">996传奇引擎玩家可直接使用游戏账号登录</div>
      <div className="login-form_box" id="login_drop">
        <Form form={form} onFinish={formSubmit} autoComplete="off">
          <Form.Item name="username">
            <Input
              placeholder="6-20个字符，由字符或数字组成"
              onCompositionStart={handleComposition}
              onCompositionEnd={handleComposition}
              onKeyUp={event => handlePercentMatchUser(event)}
              allowClear={{ clearIcon: <img className="phone_icon" src={closeImage} alt="" /> }}
              prefix={<img src={userImage} className="phone_icon" alt="" />}
              onFocus={() => focus()}
            ></Input>
          </Form.Item>
          <Form.Item name="password">
            <Input.Password
              placeholder="请设置密码"
              maxLength={20}
              onCompositionStart={handleComposition}
              onCompositionEnd={handleComposition}
              onKeyUp={event => handlePercentMatchPwd(event)}
              onFocus={() => getFocus()}
              iconRender={visible => {
                return (
                  <div>
                    {!visible ? (
                      <span className="password_icon password_hide_icon"></span>
                    ) : (
                      <span className="password_icon password_show_icon"></span>
                    )}
                  </div>
                );
              }}
              prefix={<img className="password_icon" src={luckImage} alt="" />}
              allowClear={{ clearIcon: <img className="phone_icon" src={closeImage} alt="" /> }}
            ></Input.Password>
          </Form.Item>
          <Form.Item name="recoveryPwd" style={{ marginBottom: '24px' }}>
            <Input.Password
              placeholder="两次输入的密码请保持一致"
              maxLength={20}
              onCompositionStart={handleComposition}
              onCompositionEnd={handleComposition}
              onKeyUp={event => handlePercentMatchRecoveryPwd(event)}
              onFocus={() => pwdFocus()}
              iconRender={visible => {
                return (
                  <div>
                    {!visible ? (
                      <span className="password_icon password_hide_icon"></span>
                    ) : (
                      <span className="password_icon password_show_icon"></span>
                    )}
                  </div>
                );
              }}
              prefix={<img className="password_icon" src={luckImage} alt="" />}
              allowClear={{ clearIcon: <img className="phone_icon" src={closeImage} alt="" /> }}
            ></Input.Password>
          </Form.Item>
          <Footer agreementType={2} clause={clause} setClause={setClause}></Footer>
          {!showVerify ? null : <Verify backChange={backChange} slideChange={slideChange} registerStatus={1}></Verify>}
          <Button
            style={{ display: showVerify ? 'none' : 'block' }}
            className={canSign ? 'login-form_box__submit_button' : 'login-form_box__submit_button disabled'}
            htmlType="submit"
          >
            立即注册
          </Button>
        </Form>
      </div>
      <AccountExists
        visible={dialogVisible}
        visableTitle={dialogTitle}
        current={currentNum}
        visableHint={dialogContent}
        footerBtnChange={footerBtnChange}
      ></AccountExists>
      {connectModalShow ? (
        <TemplateModal connectModelShow={connectModalShow} setConnectModelShow={setConnectModalShow} />
      ) : null}
    </div>
  );
}
export default memo(LoginSignUp);
